/* 取得現在時間字串 */
export const getNowTime = () => {
    let now = new Date()
    return now.toISOString()
}

/* 格式化時間 */
export const getFormatDate = date => {
    let dd = new Date(date)
    return dd.getFullYear() + '/' + (dd.getMonth() + 1) + '/' + dd.getDate()
}

/* 比較時間是否超過現在，傳入時間字串 */
export const compareNowForDateStr = dataStr => {
    return new Date(dataStr).getTime() > new Date().getTime()
}

/* 比較時間是否超過現在 */
export const compareNow = ({ yy, mm, dd }) => {
    let now = new Date()
    if (yy * 1 > now.getFullYear()) return true
    if (mm * 1 > now.getMonth()) return true
    if (dd * 1 > now.getDate()) return true
    return false
}

export class SoundLib {
    constructor() {
        this.sound = {}
        this.urlList = null
    }
    load(pathList) {
        pathList.forEach(path => {
            this.sound[path] = _loadAudio('/static/' + path + '.mp3')
        })
    }
    play(path) {
        let sound = this.sound[path]
        if (sound) {
            sound.play()
        } else {
            alert('聲音物件沒有載入', path)
        }
    }
    loadUrlList() {
        if (this.urlList) {
            this.urlList.forEach(url => {
                if (url && !this.sound[url]) {
                    this.sound[url] = _loadAudio(url)
                }
            })
            this.urlList = null
        }
    }
    autoPlay(path = null) {
        path = process.env.API_ROOT + path
        if (path) {
            let sound = this.sound[path]
            if (sound) {
                sound.src = sound.src
                sound.play()
                sound.pause()
                setTimeout(_ => {
                    sound.currentTime = 0
                    sound.play()
                }, 100)
            } else {
                sound = new Audio(path)
                this.sound[path] = sound
                sound.play()
                sound.pause()
                setTimeout(_ => {
                    sound.currentTime = 0
                    sound.play()
                }, 100)
            }
        }
    }
}

function _loadAudio(path) {
    let audio = new Audio()
    audio.src = path
    try {
        audio.load()
    } catch (err) {
        alert('找不到這個音效')
    }
    return audio
}

/**
 * 計時器
 */
export const Timer = {
    timeId: 0,
    count: 0,
    start() {
        this.count = 0
        this.timeId === 0 ? '' : clearInterval(this.timeId)
        this.timeId = setInterval(() => {
            this.count++
        }, 1)
    },
    timeUp() {
        clearInterval(this.timeId)
        this.timeId = 0
        return this.count
    }
}



// WEBPACK FOOTER //
// ./src/plugin/tools.js